import DragToAdvance from '@/components/DragToAdvance'
import {TweenMax, TimelineMax} from 'gsap'
import {bus} from '@/consts.js'
import MobileDrawerButton from '@/components/MobileDrawerButton'

export default {
  name: 'BracketExplorer',
  template: '#bracket-explorer-template',
  components: {DragToAdvance, MobileDrawerButton},
  data () {
    return {
      has4TeamsClass: 'bracket-explorer--4',
      has8TeamsClass: 'bracket-explorer--8',
      has16TeamsClass: 'bracket-explorer--16',
      windowSize: 'medium',
      bracketOffset: 0,
      percentage: 0,
      isTrackingFired: false,
      matchComplete: false,
      tl: {},
      bracketRound: 1
    }
  },
  props: ['dragAreaWidth', 'teamCount'],
  computed: {
    has4Teams () {
      return this.teamCount === 4
    },
    has8Teams () {
      return this.teamCount === 8
    },
    has16Teams () {
      return this.teamCount === 16
    },
    classObj () {
      return {
        'bracket-explorer--4': this.has4Teams,
        'bracket-explorer--8': this.has8Teams,
        'bracket-explorer--16': this.has16Teams
      }
    },
    bracketMatchupWidth () {
      let width = 272
      if (this.windowSize === 'small') {
        width = 220
      } else if (this.windowSize === 'large') {
        width = 390
      }
      return width
    },
    bracketRoundMargin () {
      let margin = 78
      if (this.windowSize !== 'small' && this.windowSize !== 'medium') {
        margin = 118
      }
      return margin
    },
    bracketTravelDistance () {
      let distance = this.bracketMatchupWidth + this.bracketRoundMargin
      if (this.has8Teams) {
        distance = (this.bracketMatchupWidth + this.bracketRoundMargin) * 2
      } else if (this.has16Teams) {
        distance = (this.bracketMatchupWidth + this.bracketRoundMargin) * 3
      }
      return distance * -1
    }
  },
  methods: {
    setWindowSize () {
      if (window.matchMedia('(max-width: 768px)').matches) {
        this.windowSize = 'small'
      } else if (window.matchMedia('(min-width: 1600px)').matches) {
        this.windowSize = 'large'
      } else {
        this.windowSize = 'medium'
      }
    },
    setupTimelines () {
      if (this.has4Teams) {
        this.tl.addCallback(() => {
          if (!this.isTrackingFired) {
            this.trackEvent('4-Team Bracket (Compete)', '4-Team Bracket (Compete): Toggle: Bracket Advancement')
            this.isTrackingFired = true
          }
          bus.$emit('bracket4Move1')
        }, 1)
        this.tl.addCallback(() => {
          bus.$emit('bracket4Round2')
        }, 2)
      } else if (this.has8Teams) {
        this.tl.addCallback(() => {
          if (!this.isTrackingFired) {
            this.trackEvent('8-Team Bracket (Compete)', '8-Team Bracket (Compete): Toggle: Bracket Advancement')
            bus.$emit('bracket8Round1')
            this.isTrackingFired = true
          }
        }, 1)
        this.tl.addCallback(() => {
          bus.$emit('bracket8Move1')
        }, 2)
        this.tl.addCallback(() => {
          bus.$emit('bracket8Round2')
        }, 3)
        this.tl.addCallback(() => {
          bus.$emit('bracket8Move2')
        }, 4)
        this.tl.addCallback(() => {
          bus.$emit('bracket8Round3')
        }, 5)
      } else if (this.has16Teams) {
        this.tl.addCallback(() => {
          if (!this.isTrackingFired) {
            this.trackEvent('16-Team Bracket (Compete)', '16-Team Bracket (Compete): Toggle: Bracket Advancement')
            bus.$emit('bracket16Round1')
            this.isTrackingFired = true
          }
        }, 1)
        this.tl.addCallback(() => {
          bus.$emit('bracket16Move1')
        }, 2)
        this.tl.addCallback(() => {
          bus.$emit('bracket16Round2')
        }, 3)
        this.tl.addCallback(() => {
          bus.$emit('bracket16Move2')
        }, 4)
        this.tl.addCallback(() => {
          bus.$emit('bracket16Round3')
        }, 5)
        this.tl.addCallback(() => {
          bus.$emit('bracket16Move3')
        }, 6)
        this.tl.addCallback(() => {
          bus.$emit('bracket16Round4')
        }, 7)
      }
    },
    moveBracket (draggable) {
      this.percentage = ((draggable.x / draggable.maxX) * 100) / 100
      TweenMax.to(this.tl, 1, {progress: this.percentage})
    },
    handleDrag (draggable) {
      this.moveBracket(draggable)
    },
    handleThrow (draggable) {
      this.moveBracket(draggable)
    }
  },
  mounted () {
    this.setWindowSize()
    this.tl = new TimelineMax({paused: true})
    this.setupTimelines()

    bus.$on('bracketFullAnimation', () => {
      this.tl.play()
    })

    bus.$on('browserResized', () => {
      this.setWindowSize()
    })

    if (this.has4Teams) {
      bus.$on('bracket4Move1', () => {
        this.bracketRound = this.bracketRound === 1 ? 2 : 1
        let xVal = this.bracketRound === 2 ? this.bracketTravelDistance : 0
        TweenMax.to(this.$refs.bracket, 1, { x: xVal })
      })
    } else if (this.has8Teams) {
      bus.$on('bracket8Move1', () => {
        this.bracketRound = this.bracketRound === 1 ? 2 : 1
        let xVal = this.bracketRound === 2 ? this.bracketTravelDistance / 2 : 0
        let bracketEls = this.$refs.infoCta ? [this.$refs.infoCta, this.$refs.bracket] : this.$refs.bracket
        TweenMax.to(bracketEls, 1, { x: xVal })
        if (this.$refs.infoCta) {
          let opacityVal = this.bracketRound === 2 ? 0 : 1
          let opacityDelay = this.bracketRound === 2 ? 0 : 0.5
          TweenMax.to(this.$refs.infoCta, 0.5, { opacity: opacityVal, delay: opacityDelay })
        }
      })
      bus.$on('bracket8Move2', () => {
        this.bracketRound = this.bracketRound === 2 ? 3 : 2
        let xVal = this.bracketRound === 3 ? this.bracketTravelDistance : this.bracketTravelDistance / 2
        TweenMax.to(this.$refs.bracket, 1, { x: xVal })
      })
    } else if (this.has16Teams) {
      bus.$on('bracket16Move1', () => {
        this.bracketRound = this.bracketRound === 1 ? 2 : 1
        let xVal = this.bracketRound === 2 ? this.bracketTravelDistance / 3 : 0
        TweenMax.to(this.$refs.bracket, 1, { x: xVal })
      })
      bus.$on('bracket16Move2', () => {
        this.bracketRound = this.bracketRound === 2 ? 3 : 2
        let xVal = this.bracketRound === 3 ? this.bracketTravelDistance * (2 / 3) : this.bracketTravelDistance / 3
        TweenMax.to(this.$refs.bracket, 1, { x: xVal })
      })
      bus.$on('bracket16Move3', () => {
        this.bracketRound = this.bracketRound === 3 ? 4 : 3
        let xVal = this.bracketRound === 4 ? this.bracketTravelDistance : this.bracketTravelDistance * (2 / 3)
        TweenMax.to(this.$refs.bracket, 1, { x: xVal })
      })
    }
  },
  beforeDestroy () {
    bus.$off('bracket4Move1')
    bus.$off('bracket8Move1')
    bus.$off('bracket8Move2')
    bus.$off('bracket16Move1')
    bus.$off('bracket16Move2')
    bus.$off('bracket16Move3')
  }
}



// WEBPACK FOOTER //
// ./src/components/triumph/brackets/BracketExplorer.js